import { Component } from '@angular/core';
import { DataSourceTable } from '@components/new-table/data-sources/data-source-table';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { VehicleRegistryService } from '@services/data-source-tables/vehicle-registry/vehicle-registry.service';
import { VehicleRegistryTableSettings } from '@/table-settings/vehicle-registry/vehicle-registry-table-settings';
import { TablePracticeModel } from '@/models/tables/table-practices.model';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { VehicleRegistryModel } from '@/models/vehicle-registry/vehicle-registry.model';

@Component({
  selector: 'app-vehicle-registry-page-list',
  templateUrl: './vehicle-registry-page-list.component.html',
  styleUrls: ['./vehicle-registry-page-list.component.scss'],
})
export class VehicleRegistryPageListComponent {
  displayedColumns = VehicleRegistryTableSettings.getColumnsSetting();
  dataSource = new DataSourceTable(this.vehicleRegistryService);
  reloadTrigger$ = new Subject<any>();

  constructor(
    private vehicleRegistryService: VehicleRegistryService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
  ) {}

  /* Functions temporarily disabled as API functionality is not yet available

  btnDetailsClickFunction({id}: TablePracticeModel) {
    this.router.navigate([`/vehicle-registry/detail-vehicle/${id}`])
  }

  btnDeleteFunction({id}: TablePracticeModel) {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef)

    dialogRef.afterClosed().subscribe(deleteVehicle => {
      if (deleteVehicle) {
        this.vehicleRegistryService.deleteVehicleRegistry(id).subscribe({
          next: () => {
            this.reloadTrigger$.next(1);
            this.toastr.success('Veicolo cancellato correttamente!');
          },
          error: (error) => {
            this.toastr.error(`Errore durante la cancellazione del veicolo.`);

            LoggerService.error('deleteVehicleRegistry failed!')
            LoggerService.error(error);
          },
          complete: () => {
            LoggerService.log('Request done')
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questo veicolo?'
    dialogRef.componentInstance.content = "Attenzione una volta cancellato il veicolo non sarà più possibile recuperarlo."
    dialogRef.componentInstance.firstCTA = "Si cancella"
    dialogRef.componentInstance.secondCTA = "Annulla operazione"
    dialogRef.componentInstance.closeResultFirst = true
    dialogRef.componentInstance.closeResultSecond = false
  }

  newVehicleRegistry() {
    // TODO: Implement dialog for new vehicle registry
    this.toastr.info('Funzionalità in sviluppo');
    // Reload table after potential new entry
    this.reloadTrigger$.next(1);
  }
  */
}
